import { render } from "./StoreAnalysisPage.vue?vue&type=template&id=b4a39876&ts=true"
import script from "./StoreAnalysisPage.vue?vue&type=script&lang=ts"
export * from "./StoreAnalysisPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__